/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Paper from "@mui/material/Paper";
import checkoutCartStyle from "./checkoutCartStyle";
import Container from "../../Container/Container";
import HighlightBox from "../../Box/HighlightBox/HighlightBox";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { eur } from "../../../services/formatService";
import Grid from "@mui/material/Grid";
import ProvenExpertSealStandard from "../../Provenexpert/ProvenExpertSealStandard";
import IconSsl from "../../../assets/img/generic/icon_ssl.png";
import { VAT } from "../../../services/globalVars";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";
import { Item } from "../../../types/Entities/Item";

type CheckoutCartProps = {
  item: Item;
};

const CheckoutCart = ({ item }: CheckoutCartProps) => {
  if (!item) {
    return null;
  }

  const getHeadline = (item: CheckoutCartProps["item"]) => {
    switch (item.id) {
      case 1:
      case 2:
        return item.name + " kaufen";
      case 3:
        return "Vielen Dank für die Beauftragung";
      default:
        return "";
    }
  };

  return (
    <Container>
      <Paper elevation={4} sx={checkoutCartStyle.paper}>
        <Typography variant={"h4"} sx={checkoutCartStyle.paperHeading}>
          {getHeadline(item)}
        </Typography>
        <Table sx={checkoutCartStyle.table}>
          <TableBody>
            <TableRow>
              <TableCell sx={checkoutCartStyle.tableCell}>{item.orderables[0].name}</TableCell>
              <TableCell sx={checkoutCartStyle.tableCellValue}>{eur(item.orderables[0].price)}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
        <Typography sx={checkoutCartStyle.taxHint}>Alle Preise inkl {VAT * 100}% MwSt</Typography>

        <HighlightBox headline={""} textColor={"defaultText"} textAlign={"center"}>
          {item.description}
        </HighlightBox>
        <Grid
          container
          spacing={3}
          sx={[
            {
              justifyContent: "center",
            },
            checkoutCartStyle.sealContainer,
          ]}
        >
          <Grid
            size={{
              xs: 4,
              sm: 2,
            }}
          >
            <ProvenExpertSealStandard sx={{ width: "100%", height: "auto" }} />
          </Grid>
          <Grid
            size={{
              xs: 4,
              sm: 2,
            }}
          >
            <Box component={"img"} sx={checkoutCartStyle.ssl} src={IconSsl} alt="SSL zertifiziert" />
          </Grid>
        </Grid>
      </Paper>
    </Container>
  );
};

export default CheckoutCart;
